import { timeIntervalArr } from "@ts/utils";
import DayPartingTimeComponent from "./DayPartingTimeComponent";

interface ITimePicker {
    day: string;
    containerKey: number;
    canManageDayParting: boolean
}

const DayPartingTimePicker: React.FC<ITimePicker> = ({ day, containerKey, canManageDayParting }) => {
    const timeArr = timeIntervalArr();

    return (
        <div>
            <div
                className={`${day}-select-div`}
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-evenly",
                }}
            >
                <DayPartingTimeComponent
                    timeType={"start"}
                    timeArr={timeArr}
                    cardId={`${day}-start-time-${containerKey}`}
                    canManageDayParting={canManageDayParting}

                />
                <span>-</span>
                <DayPartingTimeComponent
                    timeType={"end"}
                    timeArr={timeArr}
                    cardId={`${day}-end-time-${containerKey}`}
                    canManageDayParting={canManageDayParting}
                />
            </div>
        </div>
    );
};

export default DayPartingTimePicker;
